import React, { Component } from 'react';
import { connect } from 'react-redux';
import TrackingView from './Tracking.view';

export class TrackingContainer extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_TRACKING'
    });
  }

  render() {
    return (<TrackingView
      {...this.state}
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { tracking } = state;
  return {
    trackings: tracking.trackings,
  };
}

export default connect(mapStateToProps)(TrackingContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Tracking/Tracking.container.js